import React from 'react';

import { Text } from '../../../components/common/atom/Text';

const OrderStatus = ({ status, isVoucher = false }) => {
  return (
    <Text size={12} color="orangePink">
      {
        (isVoucher ? VOUCHER_ORDER_STATUS_SET : ORDER_STATUS_SET).filter(
          (OrderStatus) => OrderStatus[0] === status,
        )[0][1]
      }
    </Text>
  );
};

export default React.memo(OrderStatus);

const ORDER_STATUS_SET = [
  ['READY', '결제대기중'],
  ['PENDING_DEPOSIT', '입금대기중'],
  ['PAID', '결제완료'],
  ['READY_FOR_WORK', '1차 분석중'],
  ['INSPECTING', '2차 생성중 (환불불가)'],
  ['REVIEW', '2차 생성중 (환불불가)'],
  ['DENIED', '2차 생성중 (환불불가)'],
  ['RESERVED_COMPLETED', '2차 생성중 (환불불가)'],
  ['COMPLETED', '생성완료 (환불불가)'],
  ['SHIPPING_COMPLETED', '발송완료'],
  ['REFUND_REQUESTED', '환불처리중'],
  ['REFUNDED', '환불완료'],
  ['CS_REWORK', '2차 생성중 (환불불가)'],
  ['CS_REVIEW', '2차 생성중 (환불불가)'],
  ['DELEGATED', '미사용'],
];

export const OrderIsCompleted = ['COMPLETED', 'SHIPPING_COMPLETED'];
export const OrderCanBeRefunded = [
  'READY',
  'PENDING_DEPOSIT',
  'PAID',
  'READY_FOR_WORK',
];

export const Shipping = ['SHIPPING_COMPLETED'];

const VOUCHER_ORDER_STATUS_SET = [
  ['READY', '결제대기중'],
  ['PENDING_DEPOSIT', '입금대기중'],
  ['PAID', '미사용 (쿠폰 미등록)'],
  ['DELEGATED', '미사용 (쿠폰 등록완료)'],
  ['USED', '사용완료'],
  ['EXPIRED', '사용불가능'],
  ['REFUNDED', '환불완료'],
];

export const VOUCHER_ORDER_CANCEL_STATUS = [
  'PAID',
  'READY',
  'PENDING_DEPOSIT',
  'READY_FOR_WORK',
  'DELEGATED',
];
